import angular from 'angular';
import directive from './number-maxlength.directive.js';

const numberMaxlength = angular
    .module('FacilityData.Common.NumberMaxlength', [])
    .directive('numberMaxlength', directive)
    .name;

export default numberMaxlength;


// WEBPACK FOOTER //
// ./app/common/directives/number-maxlength.js